import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Tabela {
  public static async get(data: {}): Promise<GetTabelaResponse> {
    const response = await Tabela.instance.post<GetTabelaResponse>(`/tabela.php`, data);
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
